import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Graficos from '../../components/dashboard/Graficos';
import Header from '../../components/layouts/header';
import Body from '../../components/layouts/body';

class Dashboard extends React.Component {
    
    render() {
        return (
            <>
            <DashboardMenu />
            <Header titulo="Dashboard" subtitulo="Status dos itens do evento" descricao="" />
            <Body>
                <Graficos />
            </Body>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        
    }
}

export default connect(mapStateToProps)(withRouter(Dashboard));